import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme, Typography } from '@mui/material';
import {} from '@mui/icons-material';
import { GroundStation } from 'models/groundstations';

const useStyles = makeStyles(({ spacing, palette }: Theme) =>
    createStyles({
        root: {
            display: 'grid',
            marginBottom: spacing(1),
        },
        disabled: {
            color: palette.error.main,
            fontSize: 12,
        },
        subsection: {
            paddingLeft: spacing(2),
        },
        connected: {
            color: palette.success.main,
            fontSize: 12,
        },
        disconnected: {
            color: palette.error.main,
            fontSize: 12,
        },
    }),
);

interface OverviewProps {
    groundstation: GroundStation;
}

const GroundStationOverview: React.FunctionComponent<OverviewProps> = ({
    groundstation,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography variant="h6">
                {groundstation.name}{' '}
                {!groundstation.enabled && (
                    <span className={classes.disabled}>(Disabled)</span>
                )}
                {groundstation.connectionId ? (
                    <span className={classes.connected}>(Connected)</span>
                ) : (
                    <span className={classes.disconnected}>(Disconnected)</span>
                )}
            </Typography>
            <div className={classes.subsection}>
                <Typography variant="subtitle1">
                    {groundstation.organisation.name}
                </Typography>
                <Typography variant="subtitle1">
                    {groundstation.address}
                </Typography>
                <Typography variant="subtitle1">
                    {groundstation.description}
                </Typography>
            </div>
        </div>
    );
};

GroundStationOverview.displayName = 'GroundStationOverview';
export default GroundStationOverview;
